var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKodinSoftDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 456,
    viewBox: "0 0 443 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.222 473.452L78.2656 310.396L198.575 157.162H296.245L155.238 330.041L158.472 288.131L302.713 473.452H199.222ZM0 473.452V0H84.7339V473.452H0Z",
    fill: "#F8F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.607 480C375.084 480 362.363 474.761 352.445 464.284C342.527 453.806 337.568 440.928 337.568 425.648C337.568 410.368 342.527 397.49 352.445 387.012C362.363 376.535 375.084 371.296 390.607 371.296C405.7 371.296 418.205 376.535 428.123 387.012C438.041 397.49 443 410.368 443 425.648C443 440.928 438.041 453.806 428.123 464.284C418.205 474.761 405.7 480 390.607 480Z",
    fill: "#F8F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKodinSoftDot);
export default __webpack_public_path__ + "static/media/kodin-soft-dot.a235e6fa578f795ea8b560dc08aebf81.svg";
export { ForwardRef as ReactComponent };